import { gql } from '@apollo/client';

export const REQUEST_TWO_FACTOR = gql`
  query requestTwoFactor {
    two_factor @rest(type: "TwoFactor", path: "/v4/auth/2fa/regenerate") {
      id
    }
  }
`;
